<span
  class="content-change"
  [class.content-change--previous-entry]="kind === 'previous'"
  [class.content-change--new-entry]="kind === 'new'"
>
  <ng-content></ng-content>
</span>
